import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              Hipobuy<span className="font-light italic">Spreadsheet</span>
            </h3>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-md mb-8">
              Guide complet du Hipobuy Spreadsheet — mis à jour pour 2026. Tutoriels, comparatifs et analyses pour maîtriser vos données.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm whitespace-nowrap hover:bg-background-200 transition-colors cursor-pointer"
            >
              Visiter le site principal
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">Accueil</Link></li>
              <li><a href="#categories" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">Catégories</a></li>
              <li><a href="#guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">Guide Complet</a></li>
              <li><Link to="/article/guide-achat-hipobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">Guide d'Achat</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Liens Rapides</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
                  Hipobuy Spreadsheet — Site Officiel
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
                  Acheter Maintenant
                </a>
              </li>
              <li>
                <Link to="/article/guide-achat-hipobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
                  Guide d'Achat Hipobuy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              Site Principal
            </a>
            <Link to="/" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              Accueil
            </Link>
            <Link to="/article/guide-achat-hipobuy-spreadsheet" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              Guide d'Achat
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}